import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Single axios instance with credentials for httpOnly cookies
const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
});

// On any 401 outside of /auth/login, the AuthContext will handle redirect.
export default api;
